module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "activeMenu": "bookings"
    }
  }, [_c('v-panel', [_c('v-loading', {
    attrs: {
      "isLoading": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "page-header-wrapper",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "booking-filter-area white"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "booking_tle text-uppercase"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('payments.messages.title')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "booking-list",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('v-loading', {
    attrs: {
      "isLoading": _vm.loading
    }
  }), _vm._v(" "), _c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "payments-messages table table-responsive mt-20"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('input.message-type')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('input.from-number')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('input.to-number')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('input.from-email')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('input.to-email')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('input.email-subject')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('input.status')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('input.content')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.messages), function(message) {
    return _c('tr', [_c('td', [_c('div', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(message.type))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(message.from_number))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(message.to_number))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(message.from_email))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(message.to_email))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(message.email_subject))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(message.status == 1 ? "OK" : "KO"))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(message.context))])])])
  }))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42bc2bbf"}!./src/app/pages/payments/messages/messages.html
// module id = 1360
// module chunks = 0